<app-nav />
<div class="page-host"><router-outlet /></div>
<app-footer />
<app-tela-chat />
<app-toast />
